export interface ContentPart {
  type: 'text' | 'chart';
  content: string;
  chartId?: string;
}

// Matches {{chart:some-chart-id}}
const CHART_REF_RE = /\{\{chart:([^}]+)\}\}/g;

export function parseContentWithCharts(content: string): ContentPart[] {
  const parts: ContentPart[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  CHART_REF_RE.lastIndex = 0;

  while ((match = CHART_REF_RE.exec(content)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: content.slice(lastIndex, match.index) });
    }

    parts.push({ type: 'chart', content: match[0], chartId: match[1] });

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < content.length) {
    parts.push({ type: 'text', content: content.slice(lastIndex) });
  }

  return parts;
}
